import RealisasiPettyCashApi from '../__PengembalianSisaPettyCashApi__';

export const generateNoPettyCash = async (date) => {
  return await RealisasiPettyCashApi.generateNumber({ tanggal: date }).then(
    (res) => res.data.data
  );
};
